import Swiper from 'swiper/bundle';

export default class {
  constructor() {
    let that = this;

    if (document.querySelector(".hp-slider-swiper")) {
      var swiper2 = new Swiper(".hp-slider-swiper", {
        loop: false,
        spaceBetween: 10,
        navigation: {
          nextEl: ".hp-slider__nav.swiper-button-next",
          prevEl: ".hp-slider__nav.swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
        // autoplay: {
        //   delay: 5000,
        // },
      });
    }

  }
}
